import React, {Suspense} from 'react';
import './App.css';
import {HashRouter, Route, Routes} from "react-router-dom";
import {Home} from "./pages/Home";
import {Lk} from "./pages/Lk";
import {Helmet, HelmetProvider} from "react-helmet-async";
import AuthChecker from "./components/AuthChecker";
import {createStandaloneToast} from "@chakra-ui/toast";
import TfaCheck from "./components/TfaCheck";
import {Box, HStack, VStack} from "@chakra-ui/react";
import {Menu} from "./components/Menu";
import Header from "./components/Header";
import {Profile} from "./pages/Profile";
import {Security} from "./pages/Security";
import {Document} from "./pages/Document";
import {Employer} from "./pages/Employer";
import {Executor} from "./pages/Executor";
import {Template} from "./pages/Template";
import {PayoutList} from "./pages/PayoutList";
import {Withdraw} from "./pages/Withdraw";
import {CompanyInfo} from "./pages/CompanyInfo";
import {History} from "./pages/History";
import {Task} from "./pages/Task";

function App() {
    const {ToastContainer} = createStandaloneToast();
    return (
        <HelmetProvider>
            <Suspense fallback="loading">
                <Helmet>
                    <title>ArmPay</title>
                    <meta name="description" content="ArmPay"/>
                    <meta name="og:title" content="ArmPay"/>
                    <meta name="og:description" content="ArmPay"/>
                </Helmet>
                <HashRouter>
                    <ToastContainer/>
                    <AuthChecker/>
                    <TfaCheck/>
                    <HStack alignItems="start">
                        <Menu/>
                        <VStack w="100%">
                            <Header/>
                            <Box p={4} borderWidth={1} w="100%">
                                <Routes>
                                    <Route path="/" element={<Home/>}/>
                                    <Route path="/lk" element={<Lk/>}/>
                                    <Route path="/profile" element={<Profile/>}/>
                                    <Route path="/sec" element={<Security/>}/>
                                    <Route path="/doc" element={<Document/>}/>
                                    <Route path="/employer" element={<Employer/>}/>
                                    <Route path="/executor" element={<Executor/>}/>
                                    <Route path="/payout" element={<PayoutList/>}/>
                                    <Route path="/template" element={<Template/>}/>
                                    <Route path="/withdraw" element={<Withdraw/>}/>
                                    <Route path="/companyinfo" element={<CompanyInfo/>}/>
                                    <Route path="/history" element={<History/>}/>
                                    <Route path="/task" element={<Task/>}/>
                                </Routes>
                            </Box>
                        </VStack>
                    </HStack>
                </HashRouter>
            </Suspense>
        </HelmetProvider>
    );
}

export default App;
